import kusti from './kusti.jpg';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Tervitused pererahvale!</h1>
      <img src={kusti} alt="Kusti" style={{width: '100%', height: 'auto'}} />
    </div>
  );
}

export default App;
